const Panel = (props) => (
    <div className="panel">
        {props.children}
    </div>
)

export default Panel;